var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 26.6667H28",
    stroke: "#141414",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 4.66665C22.5304 4.13622 23.2499 3.83823 24 3.83823C24.3714 3.83823 24.7392 3.91139 25.0824 4.05353C25.4256 4.19567 25.7374 4.40401 26 4.66665C26.2627 4.9293 26.471 5.2411 26.6131 5.58426C26.7553 5.92742 26.8284 6.29522 26.8284 6.66666C26.8284 7.03809 26.7553 7.40589 26.6131 7.74905C26.471 8.09221 26.2627 8.40401 26 8.66666L9.33334 25.3333L4 26.6667L5.33333 21.3333L22 4.66665Z",
    stroke: "#141414",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon_edit.5ffb85db1b5e31f3a77776188366d915.svg";
export { ForwardRef as ReactComponent };